import { assetUrl } from '../../services/storefrontService.js';

export default function PageHero({ eyebrow, title, text, image }) {
  return (
    <section className="page-hero">
      {image ? <img className="page-hero-media" src={assetUrl(image)} alt="" /> : null}
      <div className="page-hero-content container">
        {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
        <h1>{title}</h1>
        {text ? <p>{text}</p> : null}
      </div>
    </section>
  );
}
